import { err, ok, type Result } from "./result";

export type OneOfParseError = { readonly kind: "notOneOf"; readonly value: string };

export const isOneOf = <Values extends readonly string[]>(
  values: Values,
  value: string,
): value is Values[number] => values.some((item) => item === value);

export const parseOneOf = <Values extends readonly string[]>(
  values: Values,
  value: string,
): Result<Values[number], OneOfParseError> =>
  isOneOf(values, value) ? ok(value) : err({ kind: "notOneOf", value });
